import { useState } from 'react';
import { Create, useRedirect } from 'react-admin';
import { GoogleAdsBridgesForm } from './GoogleAdsBridges.Form';
import { SecretDialog } from './components/SecretDialog';
import { BackButton } from '../../../helperComponents/BackButton';

export const GoogleAdsBridgesCreate = (props) => {
  const [created, setCreated] = useState(null);
  const redirect = useRedirect();

  const onSuccess = (data) => {
    setCreated(data);
  };

  const handleClose = () => {
    const id = created && created.id;
    setCreated(null);
    redirect(`/google_ads_bridges/${id}`);
  };

  return (
    <>
      <BackButton path="/google_ads_bridges" />
      <span className="h4">Connect Account</span>
      <Create {...props} title=" " redirect={false} mutationOptions={{ onSuccess }}>
        <GoogleAdsBridgesForm />
      </Create>
      <SecretDialog
        open={!!created}
        secret={created && created.secret}
        message="Shown once. Paste it into the plugin and the script now."
        onClose={handleClose}
      />
    </>
  );
};
